import { formatNumberAsCurrency, roundNumberToHundredths } from 'helpers/utils';
import { Input, NumberInput } from './styled';
import { ChangeEvent, FC, useEffect, useState, KeyboardEvent } from 'react';

const format = (value?: number) => {
  if (value === undefined) {
    return '';
  }
  return formatNumberAsCurrency(value, {
    trailingZeroDisplay: 'auto',
  });
};

interface Props {
  id: string;
  validate?: (value?: number) => string | undefined;
  value?: number;
  onBlur?: () => void;
  onChange: (value?: number) => void;
}

export const CurrencyInput: FC<Props> = ({ id, validate, value, onBlur, onChange }) => {
  const [isNumberInputVisible, setIsNumberInputVisible] = useState(false);
  // Derive from the current value so the error styling stays in sync when the
  // amount is set programmatically
  const error = validate?.(value);

  const activateInput = () => {
    setIsNumberInputVisible(true);
  };

  useEffect(() => {
    if (isNumberInputVisible) {
      document.getElementById(id)?.focus();
    }
  }, [isNumberInputVisible, id]);

  const onChangeRound = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value ? roundNumberToHundredths(e.target.value) : 0;
    onChange(newValue);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Tab' && !isNumberInputVisible) {
      activateInput();
    }
    if (e.key === 'Enter' && !isNumberInputVisible) {
      e.preventDefault();
      activateInput();
    }
  };

  const handleFocus = () => {
    if (!isNumberInputVisible) {
      activateInput();
    }
  };

  return (
    <>
      {isNumberInputVisible ? (
        <NumberInput
          className={error && 'error'}
          type="number"
          id={id}
          value={value || ''}
          onChange={onChangeRound}
          onBlur={() => {
            setIsNumberInputVisible(false);
            onBlur?.();
          }}
        />
      ) : (
        <Input
          className={error && 'error'}
          type="text"
          value={format(value)}
          onClick={activateInput}
          onKeyDown={handleKeyDown}
          onFocus={handleFocus}
          readOnly
        />
      )}
    </>
  );
};
